import api from '@pray/shared/utils/api';

/**
 * Fetches available audience options for an artist's campaigns
 * @param {string} artistId - The artist ID
 * @returns {Promise<Object>} - Response data containing audiences
 */
export async function getArtistAudiences(artistId) {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/audiences`;
  const response = await api.executeGetRequest(url);

  return response.data;
}
